import React from 'react';

export const LogicContext = React.createContext({});
export const useLogic = () => React.useContext(LogicContext);
